import { FC } from 'react';
import { useIntl } from 'react-intl';

import type { ColumnDefinition } from '../DailyBlotter.model';
import { DailyBlotterRow } from '../row/Row';
import type { DailyBlotterTableState } from './Table.connect';
import { connectDailyBlotterTable } from './Table.connect';

export interface RepriceQuoteInformation {
  instrumentName: string;
  instrumentContractName: string;
  wrapper: string;
}

export const Component: FC<DailyBlotterTableState> = ({ dailyBlotterQuotesId, dailyBlotterColumnsDefinition }) => {
  const intl = useIntl();

  return (
    dailyBlotterColumnsDefinition && (
      <table className="table table-sm table-responsive" data-e2e="dailyBlotterTable">
        <thead>
          <tr>
            {dailyBlotterColumnsDefinition.map((header: ColumnDefinition, index) => {
              return (
                <th scope="col" key={index}>
                  {intl.formatMessage({
                    id: `dailyBlotter.${header.headerName}` as any,
                    defaultMessage: header.headerName,
                  })}
                </th>
              );
            })}
            <th scope="col" key={dailyBlotterColumnsDefinition.length}></th>
          </tr>
        </thead>
        <tbody>
          {dailyBlotterQuotesId &&
            dailyBlotterQuotesId.map((quoteId: string, rowIndex) => {
              return (
                <tr key={rowIndex} data-e2e={`daily-blotter-row-${rowIndex}`}>
                  <DailyBlotterRow quoteId={quoteId} />
                </tr>
              );
            })}
        </tbody>
      </table>
    )
  );
};

export const DailyBlotterTable = connectDailyBlotterTable(Component);

DailyBlotterTable.displayName = 'DailyBlotterTable';
